import { ActionTypes } from "../constants/action-types";

const initialState = {
  newInstructor: [],
};

export const UploadInstructor = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.UPLOAD_INSTRUCTOR:
      return { ...state, newInstructor: payload };
    default:
      return state;
  }
};
